import { List, Menu, Splitter } from "antd"
import { useState } from "react"

import Flex from "#blocks/Flex"
import { ReactChild } from "#customTypes/globalTypes"

import AntdSection from "./AntdSection"

const data = [
  { label: "Item 1", key: "1" },
  { label: "Item 2", key: "2" },
  { label: "Item 3", key: "3" },
  { label: "Item 4", key: "4" },
  { label: "Item 5", key: "5" },
  { label: "Item 6", key: "6" },
  { label: "Item 7", key: "7" },
  { label: "Item 8", key: "8" },
  { label: "Item 9", key: "9" },
  { label: "Item 10", key: "10" },
  { label: "Item 11", key: "11" },
  { label: "Item 12", key: "12" },
  { label: "Item 13", key: "13" },
  { label: "Item 14", key: "14" },
  { label: "Item 15", key: "15" },
  { label: "Item 16", key: "16" },
  { label: "Item 17", key: "17" },
  { label: "Item 18", key: "18" },
]
const CARD_WIDTH = 100

const Content = ({ children }: { children: ReactChild }) => {
  return <Flex style={{ width: CARD_WIDTH }}>{children}</Flex>
}

const AntdMenus = () => {
  const [sizes, setSizes] = useState([350, 350])
  const leftColumns = Math.floor(sizes[0] / CARD_WIDTH)
  const rightColumns = Math.floor(sizes[1] / CARD_WIDTH)

  return (
    <Flex col gap={20} style={{ paddingBottom: 40 }}>
      <AntdSection title="Menu">
        <Menu
          items={[
            { label: "Tab 1", key: "1" },
            { label: "Tab 2", key: "2" },
          ]}
        />
      </AntdSection>

      <AntdSection title="Responsive Grid List with Splitter">
        <Flex style={{ width: 700 }}>
          <Splitter
            onResize={(sizes) => {
              setSizes(sizes)
            }}
            style={{ height: 200, boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)" }}
          >
            <Splitter.Panel defaultSize={sizes[0]} min="20%" max="70%">
              <List
                dataSource={data}
                renderItem={(item) => (
                  <List.Item>
                    <Content>{item.label}</Content>
                  </List.Item>
                )}
                style={{ height: 300, overflow: "scroll", padding: 20 }}
                grid={{
                  gutter: 16,
                  column: leftColumns,
                }}
              />
            </Splitter.Panel>
            <Splitter.Panel defaultSize={sizes[1]}>
              <List
                dataSource={data}
                renderItem={(item) => (
                  <List.Item>
                    <Content>{item.label}</Content>
                  </List.Item>
                )}
                style={{ height: 300, overflow: "scroll", padding: 20 }}
                grid={{
                  gutter: 16,
                  column: rightColumns,
                }}
              />
            </Splitter.Panel>
          </Splitter>
        </Flex>
      </AntdSection>
    </Flex>
  )
}

export default AntdMenus
